'use client';

import { AttentionFlashButton } from './attention-flash-button';
import { Button as ButtonRoot } from './button';
import { TransitionButton } from './transition-button';

type ButtonCompoundComponents = {
    AttentionFlash: typeof AttentionFlashButton;
    Transition: typeof TransitionButton;
};

export const Button = ButtonRoot as typeof ButtonRoot & ButtonCompoundComponents;

Button.AttentionFlash = AttentionFlashButton;
Button.Transition = TransitionButton;

export type { ButtonProps } from './button';
export type {
    AttentionFlashButtonController,
    AttentionFlashButtonProps,
    AttentionFlashButtonProviderProps,
} from './attention-flash-button';
export type { TransitionButtonContentConfig, TransitionButtonProps } from './transition-button';
